module.exports = __webpack_public_path__ + "img/patrulla_municipal_down.8f5bcfd1.svg";